"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "maccagno-con-pino-e-veddasca": {
    "383df4a3": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "skipSearch": false
    }],
    "alpe-cortiggia": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cfe94175": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "skipSearch": false
    }],
    "alpe-dei": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8fdba894": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "skipSearch": false
    }],
    "alpe-di-piero": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bd231d7b": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "skipSearch": false
    }],
    "alpe-inent": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f51f09e2": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "skipSearch": false
    }],
    "alpe-tabia": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "662932fd": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "skipSearch": false
    }],
    "bersona": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "575618ad": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "skipSearch": false
    }],
    "bosco-nassa": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "898e5a44": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "skipSearch": false
    }],
    "case-venere": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b13d02e8": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "skipSearch": false
    }],
    "caviggia": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5b21f84a": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "skipSearch": false
    }],
    "lago-d-elio": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fccfc84a": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "skipSearch": false
    }],
    "monte-borgna": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f97b62cc": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "skipSearch": false
    }],
    "mulinaccio": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "44657985": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "skipSearch": false
    }],
    "piano-della-rogna": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ba2d3a85": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "skipSearch": false
    }],
    "piano-volpera": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c052220b": [{
      "hkey": "ac425a21",
      "slug": "pino-lago-maggiore",
      "name": "Pino Lago Maggiore",
      "primary": true,
      "skipSearch": false
    }],
    "pino-sulla-sponda-del-lago-maggiore": [{
      "hkey": "ac425a21",
      "slug": "pino-lago-maggiore",
      "name": "Pino Lago Maggiore",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3fc0f148": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "skipSearch": false
    }],
    "ronco-delle-monache": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6562a3e5": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "skipSearch": false
    }],
    "ronco-valgrande": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0cbe86a8": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "skipSearch": false
    }],
    "s-rocco": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9896a3b0": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "skipSearch": false
    }],
    "sasso-della-nonna": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ac5e6df9": [{
      "hkey": "b0024b7d",
      "slug": "armio",
      "name": "Armio",
      "primary": true,
      "skipSearch": false
    }],
    "veddasca": [{
      "hkey": "b0024b7d",
      "slug": "armio",
      "name": "Armio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "maccagno-con-pino-e-veddasca"
    }],
    "04362122": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "skipSearch": false
    }],
    "veddo": [{
      "hkey": "667ef9b5",
      "slug": "maccagno-con-pino-e-veddasca",
      "name": "Maccagno con Pino e Veddasca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;